module.exports = __webpack_public_path__ + "static/media/Velocity.a8399f10.svg";